import { render, staticRenderFns } from "./detailV2.vue?vue&type=template&id=68702c64&scoped=true"
import script from "./detailV2.vue?vue&type=script&lang=js"
export * from "./detailV2.vue?vue&type=script&lang=js"
import style0 from "./detailV2.vue?vue&type=style&index=0&id=68702c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68702c64",
  null
  
)

export default component.exports